export class _Base {
    id: string;
    name: string;
    created?: any;
    modified?: any;
    owner?: string;
}